import React from 'react';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const Loading = ({ loading }) => {
  
  const isLoading = !!loading;
  
  return (
    <Backdrop open={isLoading}>
      <CircularProgress color='inherit' />
    </Backdrop>
  );
};

Loading.propTypes = {
  loading: PropTypes.bool  
};

Loading.defaultProps = {
  isLoading: false
};

export default Loading;

